
import PromotionSection from '@/graphql/queries/promotions/PromotionSection'

export default {
  vessel: {
    overlay: {
      position: 'absolute',
      width: 'full',
      pinTop: true,
      pointerEvents: 'none'
    },
    icon: {
      pointerEvents: 'auto',
      color: 'blue',
      padding: 'xs',
      fontSize: '2xl',
      backgroundColor: 'white',
      borderRadius: 'full',
      cursor: 'pointer',
      shadow: true
    },
    title: {
      font: 'serif',
      fontWeight: 'semibold',
      fontSize: '3xl'
    },
    rate: {
      $extend: 'title',
      fontWeight: 'bold',
      fontSize: '4xl',
      lineHeight: 'sm',
      lg: {
        fontSize: '5xl'
      }
    },
    details: {
      paddingY: 'sm',
      paddingX: 'sm',
      position: 'absolute',
      pinBottom: true,
      pinRight: true,
      textAlign: 'right'
    },
    tag: {
      position: 'absolute',
      pinTop: true,
      pinRight: true,
      marginRight: 'lg',
      height: 'lg',
      lg: {
        height: 'auto',
        marginRight: 'xl'
      }
    }
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: PromotionSection,
      variables: { where: { type: 'price' }, orderBy: 'sortOrder_ASC' }
    })

    this.promotion = data[0]
  },
  data() {
    return {
      promotion: null
    }
  },
  computed: {
    rate() {
      const options = this.promotion.actionsOptions.actions[0].options

      if (options.type == 'flat_percent') {
        return `-${options.options.rate * 100}%`
      } else {
        return `-${options.options.rate}€`
      }
    },
    detailsLink() {
      const promotions = this.$pagePath('promotions')
      return `${promotions}/${this.promotion.slug}`
    }
  }
}
